module.exports = __webpack_public_path__ + "static/ads-00936ab441871f8d14d5742d4fd10102.jpg";